// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__23ItM","item":"PaymentsMobile_item__1xa8e","label":"PaymentsMobile_label__3Oa2P","amount":"PaymentsMobile_amount__2zsq2"};